import { UIComponentProps, UIComponentHandler, UIComponentState, UIComponentImpl, UIDataModel } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { LoaderWrapperViewImpl } from './loaderwrapperview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { LoaderWrapperCSSStyleImpl } from './loaderwrappercss';
import * as React from 'react';

export interface LoaderWrapperComponentProps extends UIComponentProps
{
//    onSuccess(popupMsg:string):void;
//    onFailure(popupMsg:string):void;
}

export interface LoaderWrapperComponentHandler extends UIComponentHandler
{
    
}

export interface LoaderWrapperComponentState extends UIComponentState
{
    childComponent: JSX.Element;
    isShowWindow: boolean;

}

export class LoaderWrapperComponent extends UIComponentImpl<LoaderWrapperComponentProps, LoaderWrapperComponentState, UIDataModel> implements LoaderWrapperComponentHandler
{
    constructor(props: LoaderWrapperComponentProps)
    {
        super(props);

        this.state = {isShowWindow: false, childComponent: <></>};
    }

    componentDidMount()
    {
        window.scrollTo(0,100);
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        // this.setWidth("440px");
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new LoaderWrapperViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new LoaderWrapperCSSStyleImpl(applicationContext);
    }

    setWidth(width: string)
    {
        (this.getStyle() as LoaderWrapperCSSStyleImpl).setChildComponentWidth(width);
    }

    setShowWindow(isShow: boolean, childComponent: JSX.Element)
    {
        if(isShow){
            let body = document.getElementById("body-id");
            if(body){
                body.style.overflow = 'hidden';
            }
        }else
        {
            // this.setWidth("440px");

            let body = document.getElementById("body-id");
            if(body){
                body.style.overflow = 'auto';
            }
        }
        this.setState({isShowWindow: isShow, childComponent: childComponent});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/loaderwrappercomponent.tsx